/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PageInfo } from "./PageInfo";
import { Cache } from "./Cache";
import * as t from "io-ts";

// required attributes
const CacheVersionsR = t.interface({
  page_info: PageInfo,

  version_list: t.readonlyArray(Cache, "array of Cache")
});

// optional attributes
const CacheVersionsO = t.partial({});

export const CacheVersions = t.intersection(
  [CacheVersionsR, CacheVersionsO],
  "CacheVersions"
);

export type CacheVersions = t.TypeOf<typeof CacheVersions>;
